import idx from 'idx';

import { EDIT_PAGE_V2, EDIT_BLOG_V2, VIEW_PAGE } from '@confluence/named-routes';

import { getDraftShareIdFromCreateContentMetadata } from './draftShareId';
import type { ContentMetadata, ContentBlueprintMetadata } from './ContentMetadata.types';

export const createEditDraftPageUrl = (
	metadata: ContentMetadata | ContentBlueprintMetadata,
): string => {
	const data = 'content' in metadata ? metadata.content : metadata;
	const spaceKey = idx(data, (_) => _.space.key);
	const subType = data?.subType;

	if (!spaceKey) {
		return data._links.editui;
	}

	if (subType === 'live') {
		return VIEW_PAGE.toUrl({
			spaceKey,
			contentId: idx(data, (_) => _.id),
		});
	}

	return EDIT_PAGE_V2.toUrl(
		{
			spaceKey,
			contentId: idx(data, (_) => _.id),
			contentType: 'pages',
		},
		{
			query: {
				draftShareId: getDraftShareIdFromCreateContentMetadata(data),
			},
		},
	);
};

export const createEditDraftBlogUrl = (metadata: ContentMetadata): string => {
	const spaceAlias = idx(metadata, (_) => _.space.alias);
	if (!spaceAlias) {
		return metadata._links.editui;
	}

	return EDIT_BLOG_V2.toUrl(
		{
			spaceKey: spaceAlias,
			contentId: idx(metadata, (_) => _.id),
			contentType: 'blog',
		},
		{
			query: {
				draftShareId: getDraftShareIdFromCreateContentMetadata(metadata),
			},
		},
	);
};
